import { OwnAccountsTransferTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const OwnTransferTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <OwnAccountsTransferTemplate isEdit={isEdit}/>
);
